const getAgeFromBirthdate = (birthDate: string) => {
    const d_today = new Date();
    const d_birthDate = new Date(birthDate);
    let age = d_today.getFullYear() - d_birthDate.getFullYear();
    
    const m = d_today.getMonth() - d_birthDate.getMonth();
    if (m < 0 || (m === 0 && d_today.getDate() < d_birthDate.getDate())) {
        age--;
    }

    return age;
}

export default getAgeFromBirthdate